var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sharing-tab-external-section-legacy"},[_c(_setup.component,{tag:"component",attrs:{"file-info":_vm.fileInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }